module.exports = __webpack_public_path__ + "img/blue_024.39f0069b.png";